/**
 * Extract whitelist array. Used by set and string matchers
 */
export function setTransform(whitelistObject) {
    return whitelistObject.whitelist;
}
